import React, { useState } from 'react';
import {
  Card,
  Table,
  Button,
  Input,
  Select,
  Space,
  Tag,
  Modal,
  Row,
  Col,
  Statistic,
  Tooltip,
  message,
  Popconfirm,
  DatePicker,
  InputNumber,
  Descriptions,
} from 'antd';
import {
  SearchOutlined,
  ReloadOutlined,
  ExportOutlined,
  EyeOutlined,
  FilterOutlined,
  DeleteOutlined,
} from '@ant-design/icons';

const { RangePicker } = DatePicker;
const { Option } = Select;

const ActivityRewards: React.FC = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterClaimType, setFilterClaimType] = useState('all');
  const [filterRewardType, setFilterRewardType] = useState('all');
  const [agentId, setAgentId] = useState('');
  const [dateRange, setDateRange] = useState<any>(null);

  // 模拟活动奖励数据
  const rewardData = [
    {
      id: 1,
      rewardId: 'RWD_202510231200001',
      userId: 'user_001',
      username: '张三',
      agentId: 'agent_001',
      activityId: 'ACT_HBY_20251023',
      activityName: '国庆红包雨第3期',
      activityType: '红包雨',
      rewardType: 'cash', // 真金
      rewardAmount: 88.00,
      issueTime: '2025-10-23 12:00:00',
      status: '已领取',
      claimType: '自动领取',
      claimTime: '2025-10-23 12:00:01',
      expireTime: '2025-10-30 23:59:59',
      balanceId: 'BAL202510231200001',
      orderId: 'ACT_HBY_202510231200',
      rewardDesc: '红包雨活动第3轮中奖',
      remark: '',
      parentAgentId: 'parent_001',
      topAgentId: 'top_001',
    },
    {
      id: 2,
      rewardId: 'RWD_202510230800002',
      userId: 'user_001',
      username: '张三',
      agentId: 'agent_001',
      activityId: 'ACT_QD_20251023',
      activityName: '每日签到',
      activityType: '签到奖励',
      rewardType: 'cash', // 真金
      rewardAmount: 10.00,
      issueTime: '2025-10-23 08:00:00',
      status: '已领取',
      claimType: '手动领取',
      claimTime: '2025-10-23 10:30:00',
      expireTime: '2025-10-30 23:59:59',
      balanceId: 'BAL202510231030001',
      orderId: 'ACT_QD_202510230800',
      rewardDesc: '第7天签到奖励',
      remark: '',
      parentAgentId: 'parent_001',
      topAgentId: 'top_001',
    },
    {
      id: 3,
      rewardId: 'RWD_202510231400003',
      userId: 'user_001',
      username: '张三',
      agentId: 'agent_001',
      activityId: 'ACT_CZZS_20251023',
      activityName: '充100送30',
      activityType: '充值赠送',
      rewardType: 'cash', // 真金
      rewardAmount: 30.00,
      issueTime: '2025-10-23 14:00:00',
      status: '已领取',
      claimType: '自动领取',
      claimTime: '2025-10-23 14:00:00',
      expireTime: '2025-10-30 23:59:59',
      balanceId: 'BAL202510231400001',
      orderId: 'ACT_CZZS_202510231400',
      rewardDesc: '充值100元赠送30元',
      remark: '充100送30活动',
      parentAgentId: 'parent_001',
      topAgentId: 'top_001',
    },
    {
      id: 4,
      rewardId: 'RWD_202510231000004',
      userId: 'user_002',
      username: '李四',
      agentId: 'agent_002',
      activityId: 'ACT_VIP_20251023',
      activityName: 'VIP等级福利',
      activityType: 'VIP福利',
      rewardType: 'cash', // 真金
      rewardAmount: 50.00,
      issueTime: '2025-10-23 10:00:00',
      status: '待领取',
      claimType: '手动领取',
      claimTime: null,
      expireTime: '2025-10-30 23:59:59',
      balanceId: null,
      orderId: 'ACT_VIP_202510231000',
      rewardDesc: 'VIP1等级福利',
      remark: '',
      parentAgentId: 'parent_002',
      topAgentId: 'top_002',
    },
    {
      id: 5,
      rewardId: 'RWD_202510221500005',
      userId: 'user_003',
      username: '王五',
      agentId: 'agent_002',
      activityId: 'ACT_ZP_20251022',
      activityName: '幸运转盘',
      activityType: '转盘抽奖',
      rewardType: 'cash', // 真金
      rewardAmount: 20.00,
      issueTime: '2025-10-22 15:00:00',
      status: '已过期',
      claimType: '手动领取',
      claimTime: null,
      expireTime: '2025-10-29 23:59:59',
      balanceId: null,
      orderId: 'ACT_ZP_202510221500',
      rewardDesc: '转盘抽奖二等奖',
      remark: '',
      parentAgentId: 'parent_002',
      topAgentId: 'top_002',
    },
    {
      id: 6,
      rewardId: 'RWD_202510231100006',
      userId: 'user_002',
      username: '李四',
      agentId: 'agent_002',
      activityId: 'ACT_RW_20251023',
      activityName: '任务系统',
      activityType: '任务奖励',
      rewardType: 'cash', // 真金
      rewardAmount: 15.00,
      issueTime: '2025-10-23 11:00:00',
      status: '待领取',
      claimType: '手动领取',
      claimTime: null,
      expireTime: '2025-10-30 23:59:59',
      balanceId: null,
      orderId: 'ACT_RW_202510231100',
      rewardDesc: '完成任务：连续投注3次',
      remark: '',
      parentAgentId: 'parent_002',
      topAgentId: 'top_002',
    },
    {
      id: 7,
      rewardId: 'RWD_202510231600007',
      userId: 'user_004',
      username: '赵六',
      agentId: 'agent_001',
      activityId: 'ACT_XS_20251023',
      activityName: '新手引导任务',
      activityType: '任务奖励',
      rewardType: 'coupon', // 优惠券
      couponValue: 10000, // 优惠券面值(VND)
      couponCount: 2, // 优惠券张数
      rewardAmount: 20000, // 总价值 = 面值 * 张数
      issueTime: '2025-10-23 16:00:00',
      status: '已领取',
      claimType: '自动领取',
      claimTime: '2025-10-23 16:00:01',
      expireTime: '2025-10-30 23:59:59',
      usageExpireTime: '2025-10-24 16:00:00', // 使用有效期
      balanceId: null,
      orderId: 'ACT_XS_202510231600',
      rewardDesc: '完成新手任务第3步',
      remark: '',
      parentAgentId: 'parent_001',
      topAgentId: 'top_001',
    },
    {
      id: 8,
      rewardId: 'RWD_202510231800008',
      userId: 'user_005',
      username: '钱七',
      agentId: 'agent_002',
      activityId: 'ACT_ZP_20251023',
      activityName: '注册转盘',
      activityType: '转盘抽奖',
      rewardType: 'coupon', // 优惠券
      couponValue: 5000, // 优惠券面值(VND)
      couponCount: 3, // 优惠券张数
      rewardAmount: 15000, // 总价值 = 面值 * 张数
      issueTime: '2025-10-23 18:00:00',
      status: '待领取',
      claimType: '手动领取',
      claimTime: null,
      expireTime: '2025-10-30 23:59:59',
      usageExpireTime: null,
      balanceId: null,
      orderId: 'ACT_ZP_202510231800',
      rewardDesc: '转盘抽奖获得优惠券',
      remark: '',
      parentAgentId: 'parent_002',
      topAgentId: 'top_002',
    },
  ];

  const handleViewDetail = (record: any) => {
    setSelectedRecord(record);
    setDetailModalVisible(true);
  };

  const handleRefresh = () => {
    setLoading(true);
    message.loading('正在刷新数据...', 1);
    setTimeout(() => {
      setLoading(false);
      message.success('数据刷新成功！');
    }, 1500);
  };

  const handleExport = () => {
    message.loading('正在导出数据...', 1);
    setTimeout(() => {
      message.success('数据导出成功！');
    }, 1500);
  };

  const handleBatchCancel = () => {
    if (selectedRowKeys.length === 0) {
      message.warning('请选择要取消的奖励');
      return;
    }
    message.success(`已取消 ${selectedRowKeys.length} 条奖励`);
    setSelectedRowKeys([]);
  };

  const getActivityTypeColor = (type: string) => {
    const colors: Record<string, string> = {
      '红包雨': 'red',
      '转盘抽奖': 'orange',
      '签到奖励': 'blue',
      '充值赠送': 'green',
      '邀请好友': 'purple',
      'VIP福利': 'gold',
      '任务奖励': 'cyan',
      '其他': 'default',
    };
    return colors[type] || 'default';
  };

  const getStatusColor = (status: string) => {
    const colors: Record<string, string> = {
      '待领取': 'default',
      '已领取': 'success',
      '已过期': 'error',
      '已取消': 'warning',
    };
    return colors[status] || 'default';
  };

  const columns = [
    {
      title: '奖励ID',
      dataIndex: 'rewardId',
      key: 'rewardId',
      width: 180,
      fixed: 'left' as const,
      render: (text: string) => (
        <Tooltip title="点击复制">
          <span style={{ cursor: 'pointer' }} onClick={() => {
            navigator.clipboard.writeText(text);
            message.success('复制成功');
          }}>
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: '用户信息',
      key: 'userInfo',
      width: 120,
      render: (_: any, record: any) => (
        <div>
          <div style={{ fontWeight: 'bold' }}>{record.username}</div>
          <div style={{ fontSize: 12, color: '#999' }}>{record.userId}</div>
        </div>
      ),
    },
    {
      title: '活动名称',
      dataIndex: 'activityName',
      key: 'activityName',
      width: 150,
    },
    {
      title: '活动类型',
      dataIndex: 'activityType',
      key: 'activityType',
      width: 100,
      render: (type: string) => (
        <Tag color={getActivityTypeColor(type)}>{type}</Tag>
      ),
    },
    {
      title: '奖励金额',
      dataIndex: 'rewardAmount',
      key: 'rewardAmount',
      width: 150,
      sorter: (a: any, b: any) => a.rewardAmount - b.rewardAmount,
      render: (amount: number, record: any) => {
        if (record.rewardType === 'coupon') {
          // 优惠券：显示 面值*张数 = 总价值
          return (
            <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
              {record.couponValue?.toLocaleString()}VND × {record.couponCount}张
              <br />
              <span style={{ fontSize: 12, color: '#666' }}>
                = {amount.toLocaleString()}VND
              </span>
            </span>
          );
        }
        // 真金：显示金额
        return (
          <span style={{ color: '#f5222d', fontWeight: 'bold' }}>¥{amount.toFixed(2)}</span>
        );
      },
    },
    {
      title: '发放时间',
      dataIndex: 'issueTime',
      key: 'issueTime',
      width: 160,
      sorter: (a: any, b: any) => new Date(a.issueTime).getTime() - new Date(b.issueTime).getTime(),
    },
    {
      title: '发放状态',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (status: string) => (
        <Tag color={getStatusColor(status)}>{status}</Tag>
      ),
    },
    {
      title: '领取方式',
      dataIndex: 'claimType',
      key: 'claimType',
      width: 100,
    },
    {
      title: '领取时间',
      dataIndex: 'claimTime',
      key: 'claimTime',
      width: 160,
      sorter: (a: any, b: any) => {
        if (!a.claimTime && !b.claimTime) return 0;
        if (!a.claimTime) return 1;
        if (!b.claimTime) return -1;
        return new Date(a.claimTime).getTime() - new Date(b.claimTime).getTime();
      },
      render: (time: string) => time || '-',
    },
    {
      title: '账变ID',
      dataIndex: 'balanceId',
      key: 'balanceId',
      width: 180,
      render: (id: string) => id || '-',
    },
    {
      title: '奖励描述',
      dataIndex: 'rewardDesc',
      key: 'rewardDesc',
      width: 200,
      ellipsis: true,
    },
    {
      title: '操作',
      key: 'action',
      width: 150,
      fixed: 'right' as const,
      render: (_: any, record: any) => (
        <Space>
          <Tooltip title="查看详情">
            <Button type="link" icon={<EyeOutlined />} onClick={() => handleViewDetail(record)}>
              详情
            </Button>
          </Tooltip>
          {record.status === '待领取' && (
            <Popconfirm
              title="确定要取消此奖励吗？"
              onConfirm={() => message.success('奖励已取消')}
              okText="确定"
              cancelText="取消"
            >
              <Tooltip title="取消奖励">
                <Button type="link" danger icon={<DeleteOutlined />}>
                  取消
                </Button>
              </Tooltip>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  const filteredData = rewardData.filter(item => {
    const matchesSearch = !searchText || 
      item.rewardId.toLowerCase().includes(searchText.toLowerCase()) ||
      item.userId.toLowerCase().includes(searchText.toLowerCase()) ||
      item.activityName.toLowerCase().includes(searchText.toLowerCase());
    
    const matchesType = filterType === 'all' || item.activityType === filterType;
    const matchesStatus = filterStatus === 'all' || item.status === filterStatus;
    const matchesClaimType = filterClaimType === 'all' || item.claimType === filterClaimType;
    const matchesRewardType = filterRewardType === 'all' || item.rewardType === filterRewardType;
    const matchesAgent = !agentId || item.agentId === agentId;
    
    // 日期范围过滤
    const matchesDate = !dateRange || (
      new Date(item.issueTime) >= dateRange[0].toDate() &&
      new Date(item.issueTime) <= dateRange[1].toDate()
    );
    
    return matchesSearch && matchesType && matchesStatus && matchesClaimType && matchesRewardType && matchesAgent && matchesDate;
  });

  // 根据过滤后的数据计算统计数据
  const statsData = {
    totalCount: filteredData.length,
    totalAmount: filteredData.reduce((sum, item) => sum + item.rewardAmount, 0),
    claimedCount: filteredData.filter(item => item.status === '已领取').length,
    claimedAmount: filteredData.filter(item => item.status === '已领取').reduce((sum, item) => sum + item.rewardAmount, 0),
    pendingCount: filteredData.filter(item => item.status === '待领取').length,
    pendingAmount: filteredData.filter(item => item.status === '待领取').reduce((sum, item) => sum + item.rewardAmount, 0),
    expiredCount: filteredData.filter(item => item.status === '已过期').length,
    expiredAmount: filteredData.filter(item => item.status === '已过期').reduce((sum, item) => sum + item.rewardAmount, 0),
    claimRate: filteredData.length > 0 ? (filteredData.filter(item => item.status === '已领取').length / filteredData.length * 100).toFixed(1) : 0,
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: setSelectedRowKeys,
  };

  return (
    <div style={{ padding: 24 }}>
      {/* 统计卡片 */}
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <Card>
            <Statistic title="发放总笔数" value={statsData.totalCount} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="发放总金额" prefix="¥" value={statsData.totalAmount.toFixed(2)} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="已领取笔数" value={statsData.claimedCount} valueStyle={{ color: '#3f8600' }} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="已领取金额" prefix="¥" value={statsData.claimedAmount.toFixed(2)} />
          </Card>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <Card>
            <Statistic title="待领取笔数" value={statsData.pendingCount} valueStyle={{ color: '#faad14' }} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="待领取金额" prefix="¥" value={statsData.pendingAmount.toFixed(2)} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="已过期笔数" value={statsData.expiredCount} valueStyle={{ color: '#cf1322' }} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="已过期金额" prefix="¥" value={statsData.expiredAmount.toFixed(2)} />
          </Card>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={24}>
          <Card>
            <Statistic 
              title="领取率" 
              value={statsData.claimRate} 
              suffix="%" 
              valueStyle={{ fontSize: 32, fontWeight: 'bold', color: '#1890ff' }}
            />
          </Card>
        </Col>
      </Row>

      <Card
        title="活动奖励记录"
        extra={
          <Space>
            <Button
              icon={<ReloadOutlined />}
              onClick={handleRefresh}
              loading={loading}
            >
              刷新
            </Button>
            <Button
              icon={<ExportOutlined />}
              onClick={handleExport}
            >
              导出Excel
            </Button>
          </Space>
        }
      >
        {/* 搜索和筛选 */}
        <div style={{ marginBottom: 16 }}>
          <Space wrap>
            <Input
              placeholder="搜索奖励ID、用户ID或活动名称"
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 300 }}
            />
            <Select
              value={filterType}
              onChange={setFilterType}
              style={{ width: 120 }}
            >
              <Option value="all">全部类型</Option>
              <Option value="红包雨">红包雨</Option>
              <Option value="转盘抽奖">转盘抽奖</Option>
              <Option value="签到奖励">签到奖励</Option>
              <Option value="充值赠送">充值赠送</Option>
              <Option value="VIP福利">VIP福利</Option>
              <Option value="任务奖励">任务奖励</Option>
            </Select>
            <Select
              value={filterStatus}
              onChange={setFilterStatus}
              style={{ width: 120 }}
            >
              <Option value="all">全部状态</Option>
              <Option value="待领取">待领取</Option>
              <Option value="已领取">已领取</Option>
              <Option value="已过期">已过期</Option>
              <Option value="已取消">已取消</Option>
            </Select>
            <Select
              value={filterClaimType}
              onChange={setFilterClaimType}
              style={{ width: 120 }}
            >
              <Option value="all">全部方式</Option>
              <Option value="自动领取">自动领取</Option>
              <Option value="手动领取">手动领取</Option>
            </Select>
            <Select
              value={filterRewardType}
              onChange={setFilterRewardType}
              style={{ width: 120 }}
            >
              <Option value="all">全部奖励</Option>
              <Option value="cash">真金</Option>
              <Option value="coupon">优惠券</Option>
            </Select>
            <Input
              placeholder="代理ID"
              value={agentId}
              onChange={(e) => setAgentId(e.target.value)}
              style={{ width: 150 }}
              allowClear
            />
            <RangePicker
              value={dateRange}
              onChange={setDateRange}
              showTime
              style={{ width: 350 }}
              format="YYYY-MM-DD HH:mm:ss"
            />
            {selectedRowKeys.length > 0 && (
              <Popconfirm
                title={`确定要取消选中的 ${selectedRowKeys.length} 条奖励吗？`}
                onConfirm={handleBatchCancel}
                okText="确定"
                cancelText="取消"
              >
                <Button danger icon={<DeleteOutlined />}>
                  批量取消
                </Button>
              </Popconfirm>
            )}
          </Space>
        </div>

        <Table
          columns={columns}
          dataSource={filteredData}
          rowKey="id"
          rowSelection={rowSelection}
          loading={loading}
          pagination={{
            total: filteredData.length,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total) => `共 ${total} 条记录`,
          }}
          scroll={{ x: 1600 }}
        />
      </Card>

      {/* 详情模态框 */}
      <Modal
        title="奖励详情"
        open={detailModalVisible}
        onCancel={() => setDetailModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setDetailModalVisible(false)}>
            关闭
          </Button>,
        ]}
        width={700}
      >
        {selectedRecord && (
          <div>
            <Descriptions column={2} bordered>
              <Descriptions.Item label="奖励ID">{selectedRecord.rewardId}</Descriptions.Item>
              <Descriptions.Item label="用户ID">{selectedRecord.userId}</Descriptions.Item>
              <Descriptions.Item label="活动ID">{selectedRecord.activityId}</Descriptions.Item>
              <Descriptions.Item label="活动名称">{selectedRecord.activityName}</Descriptions.Item>
              <Descriptions.Item label="活动类型">
                <Tag color={getActivityTypeColor(selectedRecord.activityType)}>{selectedRecord.activityType}</Tag>
              </Descriptions.Item>
              <Descriptions.Item label="奖励类型">
                <Tag color={selectedRecord.rewardType === 'coupon' ? 'blue' : 'red'}>
                  {selectedRecord.rewardType === 'coupon' ? '优惠券' : '真金'}
                </Tag>
              </Descriptions.Item>
              <Descriptions.Item label="奖励金额">
                {selectedRecord.rewardType === 'coupon' ? (
                  <div>
                    <div>{selectedRecord.couponValue?.toLocaleString()}VND × {selectedRecord.couponCount}张</div>
                    <div style={{ color: '#666', fontSize: 12 }}>
                      总价值: {selectedRecord.rewardAmount.toLocaleString()}VND
                    </div>
                  </div>
                ) : (
                  `¥${selectedRecord.rewardAmount.toFixed(2)}`
                )}
              </Descriptions.Item>
              {selectedRecord.rewardType === 'coupon' && (
                <>
                  <Descriptions.Item label="优惠券面值">{selectedRecord.couponValue?.toLocaleString()}VND</Descriptions.Item>
                  <Descriptions.Item label="优惠券张数">{selectedRecord.couponCount}张</Descriptions.Item>
                  {selectedRecord.usageExpireTime && (
                    <Descriptions.Item label="使用有效期">{selectedRecord.usageExpireTime}</Descriptions.Item>
                  )}
                </>
              )}
              <Descriptions.Item label="发放时间">{selectedRecord.issueTime}</Descriptions.Item>
              <Descriptions.Item label="发放状态">
                <Tag color={getStatusColor(selectedRecord.status)}>{selectedRecord.status}</Tag>
              </Descriptions.Item>
              <Descriptions.Item label="领取方式">{selectedRecord.claimType}</Descriptions.Item>
              <Descriptions.Item label="领取时间">{selectedRecord.claimTime || '-'}</Descriptions.Item>
              <Descriptions.Item label="过期时间">{selectedRecord.expireTime}</Descriptions.Item>
              <Descriptions.Item label="账变ID">{selectedRecord.balanceId || '-'}</Descriptions.Item>
              <Descriptions.Item label="关联订单号">{selectedRecord.orderId}</Descriptions.Item>
              <Descriptions.Item label="奖励描述" span={2}>{selectedRecord.rewardDesc}</Descriptions.Item>
              <Descriptions.Item label="备注" span={2}>{selectedRecord.remark || '-'}</Descriptions.Item>
            </Descriptions>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ActivityRewards;

